var map = {
	"./About-us": 227,
	"./About-us.js": 227,
	"./Contact": 228,
	"./Contact.js": 228,
	"./Current-offers": 229,
	"./Current-offers.js": 229,
	"./Digital-display": 230,
	"./Digital-display.js": 230,
	"./E-shop": 231,
	"./E-shop.js": 231,
	"./Floorplan": 232,
	"./Floorplan.js": 232,
	"./Footer": 233,
	"./Footer.js": 233,
	"./Header": 234,
	"./Header.js": 234,
	"./Job-application": 235,
	"./Job-application.js": 235,
	"./Nav": 236,
	"./Nav.js": 236,
	"./News": 237,
	"./News-articles": 238,
	"./News-articles.js": 238,
	"./News.js": 237,
	"./Our-work": 239,
	"./Our-work.js": 239,
	"./Quote": 240,
	"./Quote.js": 240,
	"./Reviews": 241,
	"./Reviews.js": 241,
	"./Social-news": 242,
	"./Social-news.js": 242,
	"./Team": 243,
	"./Team.js": 243
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 879;